export default {
    NO_CALL: '통화 안됨',
    CUSTOMER_CANCEL: '고객취소',
    WRONG_RECEIVER_INFO: '고객 없음',
    SOLD_OUT: '상품 없음',
    CHANGE_STORE: '매장 변경',
    MISTAKE_ACCEPTED: '접수 실수',
    UNDERAGE: '미성년자',
    ETC: '기타',
    TEST_ORDER: '연습 오더',
    DELAY_ALLOCATED: '배차지연',
    AUTO_CANCEL: '자동취소',
    NO_CALL_FEE: '통화안됨(수수료)',
    CUSTOMER_CANCEL_FEE: '고객취소(수수료)',
    WRONG_RECEIVER_INFO_FEE: '고객 없음(수수료)',
    SOLD_OUT_FEE: '상품 없음(수수료)',
    CHANGE_STORE_FEE: '매장 변경(수수료)',
    MISTAKE_ACCEPTED_FEE: '접수 실수(수수료)',
    UNDERAGE_FEE: '미성년자(수수료)',
    ETC_FEE: '기타(수수료)',
    TEST_ORDER_FEE: '연습 오더(수수료)',
    DELAY_ALLOCATED_FEE: '배차지연(수수료)',
    AUTO_CANCEL_FEE: '자동취소(수수료)',
};
